import { addRTSliceConfigCombineReducer, cargoSliceReducer } from './index';
import { CARGO_SLICE_NAME } from './cargo/cargo.const';

export const CARGO_SLICE_COMBINE = {
  cargo: {
    name: CARGO_SLICE_NAME,
    reducer: cargoSliceReducer,
  },
  addRT: addRTSliceConfigCombineReducer,
} as const;
